import type { AuthProvider } from './auth-provider'
import { AzureB2CProvider } from './azure-b2c-provider'

let instance: AuthProvider | null = null

export function getAuthProvider(): AuthProvider {
  if (!instance) {
    const provider = import.meta.env['VITE_AUTH_PROVIDER'] as string | undefined

    switch (provider) {
      case 'azure-b2c':
      default:
        instance = new AzureB2CProvider()
    }
  }
  return instance
}
